import { privateApi } from '../ApiService';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import {
    LeadsConversation,
    AssigneeUnreadLeadConversations,
    TalentsConversationsUnreadCountsByUser,
    TalentpoolUnreadLeadConversations,
    TagUnreadLeadConversations,
} from './types';
import { TalentConversationLocation } from 'lib/enum/lead-conversation-location';

const fetchLeadsConversations = (
    businessAccountId: string,
    settings?: Record<string, any>,
    extendUrl?: string,
): Promise<LeadsConversation[]> =>
    privateApi.get<LeadsConversation[]>(
        `business-accounts/${businessAccountId}/leads-conversations${extendUrl || ''}`,
        settings,
    );

const fetchUnreadConversationsCounts = (
    businessAccountId: string,
    userId: string,
    location: TalentConversationLocation,
): Promise<TalentsConversationsUnreadCountsByUser> =>
    privateApi.get<TalentsConversationsUnreadCountsByUser>(
        `business-accounts/${businessAccountId}/leads-conversations/unread-counts-by-user/${userId}?${new URLSearchParams(
            { location },
        )}`,
    );

const fetchUnreadCountPerAssignee = (
    businessAccountId: string,
    location: TalentConversationLocation,
): Promise<AssigneeUnreadLeadConversations[]> =>
    privateApi.get<AssigneeUnreadLeadConversations[]>(
        `business-accounts/${businessAccountId}/leads-conversations/unread-count-per-assignee?${new URLSearchParams({
            location,
        })}`,
    );

const fetchUnreadCountPerTalentpool = (
    businessAccountId: string,
    location: TalentConversationLocation,
): Promise<TalentpoolUnreadLeadConversations[]> =>
    privateApi.get<TalentpoolUnreadLeadConversations[]>(
        `business-accounts/${businessAccountId}/leads-conversations/unread-count-per-talentpool?${new URLSearchParams({
            location,
        })}`,
    );

const fetchUnreadCountPerTag = (
    businessAccountId: string,
    location: TalentConversationLocation,
): Promise<TagUnreadLeadConversations[]> =>
    privateApi.get<TagUnreadLeadConversations[]>(
        `business-accounts/${businessAccountId}/leads-conversations/unread-count-per-tag?${new URLSearchParams({
            location,
        })}`,
    );

export const LeadsConversationGateway = {
    fetchLeadsConversations,
    fetchUnreadConversationsCounts,
    fetchUnreadCountPerAssignee,
    fetchUnreadCountPerTalentpool,
    fetchUnreadCountPerTag,
};

const cancelableFetchLeadsConversations = (
    businessAccountId: string,
    settings?: Record<string, any>,
    extendUrl?: string,
): Promise<LeadsConversation[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<LeadsConversation[]>(
        `business-accounts/${businessAccountId}/leads-conversations${extendUrl || ''}`,
        settings,
    );

const cancelableFetchUnreadConversationsCounts = (
    businessAccountId: string,
    userId: string,
    location: TalentConversationLocation,
): Promise<TalentsConversationsUnreadCountsByUser> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<TalentsConversationsUnreadCountsByUser>(
        `business-accounts/${businessAccountId}/leads-conversations/unread-counts-by-user/${userId}?${new URLSearchParams(
            { location },
        )}`,
    );

const cancelableFetchUnreadCountPerAssignee = (
    businessAccountId: string,
    location: TalentConversationLocation,
): Promise<AssigneeUnreadLeadConversations[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<AssigneeUnreadLeadConversations[]>(
        `business-accounts/${businessAccountId}/leads-conversations/unread-count-per-assignee?${new URLSearchParams({
            location,
        })}`,
    );

export const CancelableLeadsConversationGateway = {
    cancelableFetchLeadsConversations,
    cancelableFetchUnreadConversationsCounts,
    cancelableFetchUnreadCountPerAssignee,
};
